import React from 'react';

import classes from './SmallSpinnerLight.module.css';

const SmallSpinnerLight = (props) => (
    <div className={classes.Loader}>Loading...</div>
);


  
export default SmallSpinnerLight;